<template>
  <div class="ligatureMain">
    <h1 class="padding title page-title">
      Расчет лигатуры
    </h1>
    <select-metal
      v-model="selectedMetal"
    />
    <div class="selectBox padding">
      <div class="ligatureMain-selectBlock selectWidth">
        <div class="text">
          Выберете сплав/пробу
        </div>
        <CastomSelect
            :options="options"
            placeholder="Проба/сплав"
            v-model="selectedValue"
        />
      </div>
      <div class="ligatureMain-selectBlock inputWidth">
        <div class="text">
          Вес чистого металла г.
        </div>
        <CastomInput
          v-model="selectedInput"
          :selectedMetal="selectedMetal"
        />
      </div>
    </div>
    <metals-list
        :metals="metals.value"
    />
    <div
        class="chain-results flexColumn"
        v-if="finalWeight || totalPrice"
    >
      <div class="chain-results-string flexRow" v-if="finalWeight">
        <div class="chain-results-string_title">Общий вес </div>
        <div class="chain-results-string_num">{{finalWeight}}</div>
        <div class="chain-results-string_type">г</div>
      </div>
      <div class="chain-results-string flexRow" v-if="totalPrice">
        <div class="chain-results-string_title">Общая стоимость</div>
        <div class="chain-results-string_num">{{formatPrice(totalPrice)}}</div>
        <div class="chain-results-string_type">₽</div>
      </div>
    </div>
  </div>
</template>

<script setup>/* eslint-disable */
import CastomSelect from "@/components/selects/CastomSelect";
import {computed, reactive, ref, watch} from "vue";
import SelectMetal from "@/components/selects/SelectMetal";
import CastomInput from "@/components/inputs/CastomInput";
import GoldSample from "@/jsonData/GoldSample.json"
import SilverSample from "@/jsonData/SilverSample.json"
import {useMetalsStore} from "@/stores/metalsPrice/metalsStore";
import MetalsList from './MetalsList'
import { formatPrice } from '@/helpers/helpers'
import { useComputedCalculationTracking } from '@/helpers/calculationAnalytics'

const metalsStore = useMetalsStore();


console.log(metalsStore.data, "temp")

const selectedMetal = ref('silver')
const selectedValue = ref(null);
const selectedInput = ref(null);
const metals = reactive({
  value: []
})
const finalWeight = ref(null)
const totalPrice = computed(() => {
  const sum = (metals.value ?? []).reduce((acc, metal) => {
    const p = Number(metal?.price)
    return acc + (Number.isFinite(p) ? p : 0)
  }, 0)
  return sum > 0 ? sum.toFixed(2) : null
})
useComputedCalculationTracking('ligature', finalWeight)
if (window.gtag) {
  window.gtag('event', 'ligature_calculator', {})
}
const setMetalArray = () => {
  const selectedSample = selectedValue.value;

  if (!selectedSample || typeof selectedSample !== 'object') {
    metals.value = [];
    return;
  }

  const result = [];
  const keys = Object.keys(selectedSample);
  keys.forEach(key => {
    if (selectedSample[key]) {
      const filteredMetals = metalsStore.metalsObj
          .filter(metal => key === metal.tableName)
          .map(metal => ({
            name: metal.name,
            color: metal.color,
            weight: 0,
            borderColor: metal.borderColor,
            percent: selectedSample[key],
            tableName: metal.tableName,
          }));
      result.push(...filteredMetals);
    }
  });
  metals.value = result;
};

const setPrice = (metal) => {
  let priceMetal = 0
  switch (metal) {
    case 'Серебро':
      priceMetal = metalsStore.data.silver
      break
    case 'Золото':
      priceMetal = metalsStore.data.gold
      break
    case 'Платина':
      priceMetal = metalsStore.data.platinum
      break
    case 'Палладий':
      priceMetal = metalsStore.data.palladium
      break
  }
  return priceMetal
}

const setWeight = () => {
  const basicMetal = metals.value.find(metal => {
    if(selectedMetal.value === 'silver') {
      return metal.tableName === 'Ag'
    }
    if(selectedMetal.value === 'gold') {
      return metal.tableName === 'Au'
    }
  })
  const totalWeight = (selectedInput.value/(basicMetal.percent/100)).toFixed(2)
  finalWeight.value = totalWeight
  metals.value = metals.value.map(metal =>{
    console.log((setPrice(metal.name) * (metal.weight = (metal.percent * totalWeight)/100).toFixed(2)).toFixed(2))
    return {
      name: metal.name,
      color: metal.color,
      weight: (metal.weight = (metal.percent * totalWeight)/100).toFixed(2),
      percent: metal.percent,
      tableName: metal.tableName,
      borderColor: metal.borderColor,
      price: (setPrice(metal.name) * (metal.weight = (metal.percent * totalWeight)/100).toFixed(2)).toFixed(2) ?? 0
    }
  })
}

watch(selectedValue, (newValue) => {
  if (!newValue) {
    metals.value = []
    finalWeight.value = null
    return
  }

  setMetalArray()
  if(metals.value.length && selectedInput.value) {
    setWeight()
  }
})
watch(selectedInput, (newValue) => {
  if(metals.value.length) {
    setWeight()
  }
})
watch(selectedMetal, (newValue) => {
  finalWeight.value = null

  metals.value = []
  selectedValue.value = null
  selectedInput.value = ''
})
const options = computed(() =>{
  return selectedMetal.value === 'silver' ? SilverSample.silver : GoldSample.gold
})

</script>

<style lang="scss" scoped>
.ligatureMain {
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  justify-content: start;
  text-align: center;
  height: calc(100vh - 140px);;
  color: white;
  width: 100%;
  &-selectBlock {
    text-align: center;
    align-items: center;
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 10px;
  }
}
.selectBox {
  display: flex;
  justify-content: space-around;
  margin-top: 40px;
}
.inputWidth {
  width: 20vw;
}
.selectWidth {
  width: 40vw;
}
.text {
  color: white;
}
.title {
  border-bottom: 2px solid white;
  margin-bottom: 10px;
}
.flexColumn {
  display: flex;
  flex-direction: column;
}
.flexRow {
  display: flex;
  flex-direction: row;
}
</style>
